import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawPuinModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Puin/Sloopafval");

		this.name = "puin";
		this.icon = svg_puin;
		this.svgTextIndex = 1;
	}
}

window.customElements.define("inspx-draw-puin-module", DrawPuinModule);

const svg_puin = (text) => html`
<svg width="90" height="30.000000000000004" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
 <g>
  <title>Layer 1</title>
  <rect fill="#7c2300" stroke-width="1px" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="0.94922" y="0.70715" width="88" height="29" id="svg_4" rx="11" ry="11" stroke="black"/>
  <text font-weight="bold" transform="matrix(0.47459677253315224,0,0,0.7288229121657892,90.48037196839825,-122.11194687961834) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_1" y="196.27043" x="-96.26081" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000" stroke="black">${text}</text>
 </g>
</svg>
`;
